import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import { SiteConfigProvider } from "@/lib/siteConfig";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import { Login } from "@/pages/Auth";
// import { ForgotPassword, ResetPassword } from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";
import UsedMarket from "@/pages/UsedMarket";
import LegalPage from "./pages/LegalPage";
import ContactPage from "@/pages/ContactPage";

function PublicLayout() {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <SiteConfigProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
            <Route path="/condizioni-vendita" element={<LegalPage />} />
            <Route path="/diritto-recesso" element={<LegalPage />} />
            <Route path="/privacy-policy" element={<LegalPage />} />
            <Route path="/cookie-policy" element={<LegalPage />} />
            <Route path="/termini-e-condizioni" element={<LegalPage />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/mercatino" element={<UsedMarket />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/login" element={<Login />} />
                <Route path="/dove-siamo" element={<ContactPage />} />
                {/* Rotte recupero password disattivate */}
                {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
                {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
              </Route>
            </Routes>
          </BrowserRouter>
        </SiteConfigProvider>
      </CartProvider>
    </AuthProvider>
  );
}